const AccBalanceSummary = { data: [], loading: true };
export const GetAccBalanceSummary = (state = AccBalanceSummary, action) => {
  switch (action.type) {
    case "get_allaccbalance":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
const initialState = {
  cashSummary: null,
  loading: false,
};

export const cashSummaryReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_CASH_SUMMARY":
      return {
        ...state,
        cashSummary: action.payload,
      };
    default:
      return state;
  }
};
const cashState = {
  cashSummary2: null,
  loading: false,
};

export const cashSummaryReducer2 = (state = cashState, action) => {
  switch (action.type) {
    case "GET_CASH_SUMMARY2":
      return {
        ...state,
        cashSummary2: action.payload,
      };
    default:
      return state;
  }
};
const taxState2 = {
  taxSummary2: null,
  loading: false,
};

export const taxSummaryReducer2 = (state = taxState2, action) => {
  switch (action.type) {
    case "GET_TAX_SUMMARY2":
      return {
        ...state,
        taxSummary2: action.payload,
      };
    default:
      return state;
  }
};
const taxState = {
  taxSummary: null,
  loading: false,
};

export const taxSummaryReducer = (state = taxState, action) => {
  switch (action.type) {
    case "GET_TAX_SUMMARY":
      return {
        ...state,
        taxSummary: action.payload,
      };
    default:
      return state;
  }
};
const coaState2 = {
  coaSummary2: null,
  loading: false,
};

export const coaSummaryReducer2 = (state = coaState2, action) => {
  switch (action.type) {
    case "GET_COA_SUMMARY2":
      return {
        ...state,
        coaSummary2: action.payload,
      };
    default:
      return state;
  }
};
const coaState = {
  coaSummary: null,
  loading: false,
};

export const coaSummaryReducer = (state = coaState, action) => {
  switch (action.type) {
    case "GET_COA_SUMMARY":
      return {
        ...state,
        coaSummary: action.payload,
      };
    default:
      return state;
  }
};
const initialStateLand = {
  data: [],
  cashInHand: 0,
  openingBalance: 0,
  credit: 0,
  debit: 0,
};

export const landPaymentReducer = (state = initialStateLand, action) => {
  switch (action.type) {
    case "GET_LAND_PAYMENT":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
